var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFewCloudsDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2{fill:none;stroke:#efcc00;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, 65.8, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 46.72,
    x2: 25.63,
    y1: 58.39,
    y2: 31.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, 109.04, 59.43)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: 12.25,
    x2: 23.86,
    y1: 56.93,
    y2: 74.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.8,
    cy: 28,
    r: 12.59
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 8,
    y2: 12.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 43.56,
    y2: 48
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.8,
    x2: 24.25,
    y1: 28,
    y2: 28
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.36,
    x2: 59.8,
    y1: 28,
    y2: 28
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 13.86,
    y2: 17
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 39,
    y2: 42.14
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 42.14,
    y2: 39
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 17,
    y2: 13.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.5,21.9A17.49,17.49,0,0,1,39,31.22a13.75,13.75,0,1,1,6.92,25.62L23.5,56.9a17.5,17.5,0,0,1,0-35Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 45.89,
    cy: 43.09,
    r: 13.75,
    transform: "translate(-7.96 75.69) rotate(-74.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsDay);
export default __webpack_public_path__ + "static/media/few_clouds_day.2e92f9eb6fae744a5aba7dad1755c58b.svg";
export { ForwardRef as ReactComponent };